var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 37,
    viewBox: "0 0 47 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M0.359375 36.8203L1.90625 26.8359C2.42188 23.4609 3.38281 20.2266 4.78906 17.1328C6.19531 13.9922 7.92969 11.0391 9.99219 8.27344C12.0547 5.50781 14.3516 3.02344 16.8828 0.820312L25.1094 6.375C23.1875 9.60938 21.4531 12.8672 19.9062 16.1484C18.3594 19.4297 17.2578 22.9453 16.6016 26.6953L14.8438 36.8203H0.359375ZM21.3125 36.8203L22.8594 26.8359C23.375 23.4609 24.3359 20.2266 25.7422 17.1328C27.1484 13.9922 28.8828 11.0391 30.9453 8.27344C33.0078 5.50781 35.3047 3.02344 37.8359 0.820312L46.0625 6.375C44.1406 9.60938 42.4062 12.8672 40.8594 16.1484C39.3125 19.4297 38.2109 22.9453 37.5547 26.6953L35.7969 36.8203H21.3125Z",
    fill: "#95A6B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.acd2b4449a76e6c48dff5fa59d1d1a60.svg";
export { ForwardRef as ReactComponent };